import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('wingsdiet_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      if (token) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` }
          });
          setAdmin(response.data);
        } catch (error) {
          console.error('Token verification failed:', error);
          localStorage.removeItem('wingsdiet_token');
          setToken(null);
          setAdmin(null);
        }
      }
      setLoading(false);
    };

    verifyToken();
  }, [token]);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { access_token, admin: adminData } = response.data;
    
    localStorage.setItem('wingsdiet_token', access_token);
    setToken(access_token);
    setAdmin(adminData);
    
    return response.data;
  };

  const register = async (email, password, name) => {
    const response = await axios.post(`${API}/auth/register`, { email, password, name });
    const { access_token, admin: adminData } = response.data;
    
    localStorage.setItem('wingsdiet_token', access_token);
    setToken(access_token);
    setAdmin(adminData);
    
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem('wingsdiet_token');
    setToken(null);
    setAdmin(null);
  };

  const getAuthHeaders = () => ({
    Authorization: `Bearer ${token}`
  });

  const value = {
    admin,
    token,
    loading,
    isAuthenticated: !!admin,
    login,
    register,
    logout,
    getAuthHeaders
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
